import { Component, inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CorTema, TemaService } from 'app/core/services/tema.service';
import { environment } from '../../../../environments/environment';

interface OpcaoCor {
  valor: CorTema;
  rotulo: string;
}

@Component({
  selector: 'app-tema',
  imports: [MatTooltipModule],
  templateUrl: './tema.component.html',
  styleUrls: ['./tema.component.css']
})
export class TemaComponent {

  private readonly tema = inject(TemaService);

  readonly corSelecionada = this.tema.corSelecionada;
  readonly producao = environment.production;

  readonly cores: readonly OpcaoCor[] = [
    { valor: 'grey', rotulo: 'cinza' },
    { valor: 'blue', rotulo: 'azul' },
    { valor: 'green', rotulo: 'verde' },
    { valor: 'red', rotulo: 'vermelha' },
    { valor: 'yellow', rotulo: 'amarela' },
    { valor: 'pink', rotulo: 'rosa' },
    { valor: 'ciano', rotulo: 'ciano' },
    { valor: 'purple', rotulo: 'roxa' },
  ];

  selecionarCor(cor: CorTema) {
    this.tema.definirCor(cor);
  }
}
